import React from 'react';
import { Select, SelectProps } from '@economic/taco';
import useCachedQuery from '../../hooks/useCachedQuery';

export default function KeyFigureCodeDropdown(props: SelectProps) {
    const query = useCachedQuery('/key-figure-codes', []);

    const data = query.data.map(keyFigureCode => ({
        data: keyFigureCode,
        text: keyFigureCode.name,
        value: keyFigureCode.id,
    }));

    return <Select {...props} data={data} loading={query.loading} className="w-24" />;
}
